import * as React from 'react';
import * as ReactDOM from 'react-dom';

// import DevTools from 'mobx-react-devtools';

import Chrome from '@crochik/pi-react/ui/material/SimpleChrome';
import Theme from './Theme';
import init from './app';

import './index.css';

export class Main extends React.Component {
  componentWillMount() {
    init();
  }

  render() {
    return (
      <Chrome />
    );
  }
}

const AppWithTheme = Theme(Main);

function launch(id: string, args?: {}) {
  if (args) {
    var req = {
      searchParams: args
    };
    sessionStorage.setItem('request', JSON.stringify(req));
  }

  ReactDOM.render(
    <AppWithTheme />,
    document.getElementById(id) as HTMLElement
  );
}

window['piBooking'] = launch;



// WEBPACK FOOTER //
// ./src/index.tsx